import { MyLessons, NewLesson } from "@/types/MyLessons";
import { ActionTree, Commit } from "vuex";
import { State } from "./orai";
import axios, { CancelTokenSource } from "axios";
import consts from "@/consts";
import { LearnerRecordings } from "@/types/LearnerRecordings";
import {
  Team,
  TeamActivity,
  TeamEngagement,
  TeamLeaderboard,
  TeamPerformance,
  UserStat,
  User,
  TeamLesson,
  UserMeta,
  TeamCompletion,
  UserPlan,
  License,
  Review,
  LearnerReviews,
  LearnerTeam,
  AvailablePlan,
} from "@/types";

export var source = refreshAxiosCancelToken();

export function refreshAxiosCancelToken(): CancelTokenSource {
  const CancelToken = axios.CancelToken;
  source = CancelToken.source();
  return source;
}

export function handleError(commit: Commit, error: any) {
  if (!axios.isCancel(error)) {
    const errorMsg = error.response.data.Error;
    if (errorMsg && errorMsg.length > 0) {
      commit("setDisplayError", errorMsg);
    }
  }
}

export const actions: ActionTree<State, any> = {
  resetState({ commit }): any {
    commit("resetState");
  },
  setJWT({ commit }, jwt: string): any {
    commit("setJWT", jwt);
  },
  setInitAssessment({ commit }, doneOnboarding: boolean): any {
    let domain = window.location.href;
    (window as any).$cookies.set("DONE_ONBOARD", doneOnboarding, "/", domain);
    commit("setInitAssessment", doneOnboarding);
  },
  setUID({ commit }, uid: string): any {
    commit("setUID", uid);
    /* axios({
      url: consts.serverURL+'user/'+uid+'/frontchat-identity',
      headers: {
        Authentication: this.getters.JWT
      },
      cancelToken: source.token
    }).then(
      response => {
        if (response && response.data) {
          (window as any).FrontChat('identity', response.data);
        }
      }, error => {
        console.error(error);
      }); */
  },
  setCurrentTeam({ commit }, team: Team): any {
    commit("setTeam", team);
  },
  setLearnerLessons({ commit }, myLessons: NewLesson[]): any {
    commit("learnerLessons", myLessons);
  },
  setCurrentLearnerTeam({ commit }, team: LearnerTeam): any {
    commit("setLearnerTeam", team);
  },
  setDisplayError({ commit }, error: any): any {
    commit("setDisplayError", error);
  },
  setRecordedVideoURL({ commit }, url: string | null): any {
    commit("setRecordedVideoURL", url);
  },
  setTranscriptStartIndex({ commit }, startIndex: number): any {
    commit("setTranscriptStartIndex", startIndex);
  },
  setTranscriptEndIndex({ commit }, endIndex: number): any {
    commit("setTranscriptEndIndex", endIndex);
  },
  setReviewCommentSelectedIndex({ commit }, index: number): any {
    commit("setReviewCommentSelectedIndex", index);
  },
  setReviewCommentPlay({ commit }, index: number): any {
    commit("setReviewCommentPlay", index);
  },
  setNewReviewCommentVisible({ commit }, isVisible: boolean): any {
    commit("setNewReviewCommentVisible", isVisible);
  },
  setRubricData({ commit }, rubricData): any {
    commit("setRubricData", rubricData);
  },
  setRubricSessionAnswers({ commit }, rubricSessionAnswers): any {
    commit("setRubricSessionAnswers", rubricSessionAnswers);
  },
  setRubricSessionAnswersByUser({ commit }, rubricSessionAnswersByUser): any {
    commit("setRubricSessionAnswersByUser", rubricSessionAnswersByUser);
  },
  setRubricSessionAverageAnswers({ commit }, rubricSessionAverageAnswers): any {
    commit("setRubricSessionAverageAnswers", rubricSessionAverageAnswers);
  },
  setReviewFeedbackComments({ commit }, reviewFeedbackComments): any {
    commit("setReviewFeedbackComments", reviewFeedbackComments);
  },
  setTeamReviewSettings({ commit }, teamReviewSettings): any {
    commit("setTeamReviewSettings", teamReviewSettings);
  },
  fetchMyLessons({ commit, getters }): any {
    let url: string;
    if (getters.currentLearnerTeamID) {
      url =
        consts.serverURL +
        "my_lessons_new/" +
        getters.UID +
        "/" +
        getters.currentLearnerTeamID +
        "?journey_enabled=false";
    } else {
      url =
        consts.serverURL +
        "my_lessons_new/" +
        getters.UID +
        "?journey_enabled=false";
    }

    axios({
      url: url,
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        const payload: NewLesson[] = response && response.data;
        commit("learnerLessons", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  async fetchCurrentTeam({ commit, getters }) {
    await axios({
      url: consts.serverURL + "team/" + getters.currentTeamID,
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Current Team Action", response.data);
        const payload: Team = response && response.data;
        commit("setTeam", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  async fetchCurrentTeamLicenses({ commit, getters }) {
    await axios({
      url:
        consts.serverURL +
        "enterprise/" +
        getters.currentTeam.EnterpriseID +
        "/licenses/",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Enterprise Licenses Action", response.data);
        if (response.data.length) {
          let currentTeam = getters.currentTeam;
          currentTeam.DefaultLicenseID = response.data[0].ID;
          commit("setTeam", currentTeam);
        }
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchCurrentTeamStats({ commit, getters }): any {
    axios({
      url:
        consts.serverURL + "team/" + getters.currentTeamID + "/user_statistics",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Current Team Stats Action", response.data);
        const payload: UserStat[] = response && response.data;
        commit("setCurrentTeamStats", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchCurrentTeamActivity({ commit, getters }): any {
    axios({
      url: consts.serverURL + "team/" + getters.currentTeamID + "/activity",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Current Team Activity Action", response.data);
        let payload: TeamActivity[] = [];
        if (response && response.data) {
          payload = response && response.data;
        }
        commit("setCurrentTeamActivity", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamUsers({ commit, getters }, tid: Number): any {
    axios({
      url: consts.serverURL + "team/" + tid + "/users",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Team Users Action", response.data);
        const payload: User[] = response && response.data;
        commit("setCurrentTeamUsers", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },

  fetchLearnerRecordings({ commit, getters }): any {
    axios({
      url: `${consts.serverURL}/user/${getters.UID}/profilestats/recordings?limit=100&offset=0`,
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    })
      .then((response) => {
        const payload: LearnerRecordings = response && response.data;
        console.log(payload);
        commit("learnerRecordings", payload);
      })
      .catch((error) => {
        handleError(commit, error);
      });
  },
  fetchLearnerReviews({ commit, getters }): any {
    axios({
      url: `${consts.serverURL}/review/my_reviews`,
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    })
      .then((response) => {
        const payload: LearnerReviews[] = response && response.data;
        let reviewedList: LearnerReviews[] = [];
        if (payload) {
          reviewedList = payload.filter((learnerReview) => {
            return (
              learnerReview.reviewedOn && learnerReview.reviewedOn !== null
            );
          });
        }
        console.log(payload);
        commit("learnerReviews", reviewedList);
      })
      .catch((error) => {
        handleError(commit, error);
      });
  },
  async fetchTeams({ commit, getters }) {
    await axios({
      url: [consts.serverURL, "user", getters.UID, "teams"].join("/"),
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("fetch team action:" + response);
        const payload: Team[] = response && response.data;
        commit("setTeams", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamLessons({ commit, getters }, tid: Number): any {
    axios({
      url: [consts.serverURL, "lessons/team", tid].join("/"),
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        const payload: TeamLesson[] = response && response.data;
        commit("setTeamLessons", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchUserMeta({ commit, getters }): any {
    axios({
      url: [consts.serverURL, "user", getters.UID, "meta"].join("/"),
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        const userMeta: UserMeta = response && response.data;
        commit("setUserMeta", userMeta);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamEngagement({ commit, getters }, tid: Number): any {
    axios({
      url: consts.serverURL + "team/" + tid + "/engagement",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("ENGAGEMENT Action", response.data);
        const payload: TeamEngagement = response && response.data;
        commit("setTeamEngagement", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamCompletion({ commit, getters }, tid: Number): any {
    axios({
      url: consts.serverURL + "team/" + tid + "/lessoncompletion",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("COMPLETION Action", response.data);
        const payload: TeamCompletion = response && response.data;
        commit("setTeamCompletion", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamLeaderboard({ commit, getters }, tid: Number): any {
    axios({
      url: consts.serverURL + "team/" + tid + "/leaderboard",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("LEADERBOARD Action", response.data);
        const payload: TeamLeaderboard = response && response.data;
        commit("setTeamLeaderboard", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamPerformanceOverall({ commit, getters }, tid: Number): any {
    axios({
      url: consts.serverURL + "team/" + tid + "/improvement/overall",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Overall Action", response.data);
        const payload: TeamPerformance = response && response.data;
        commit("setTeamPerformanceOverall", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamPerformancePace({ commit, getters }, tid: Number): any {
    axios({
      url: consts.serverURL + "team/" + tid + "/improvement/pace",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Pace Action", response.data);
        const payload: TeamPerformance = response && response.data;
        commit("setTeamPerformancePace", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamPerformanceConciseness({ commit, getters }, tid: Number): any {
    axios({
      url: consts.serverURL + "team/" + tid + "/improvement/conciseness",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("conciseness Action", response.data);
        const payload: TeamPerformance = response && response.data;
        commit("setTeamPerformanceConciseness", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchTeamPerformanceFillers({ commit, getters }, tid: Number): any {
    axios({
      url: consts.serverURL + "team/" + tid + "/improvement/filler",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Fillers Action", response.data);
        const payload: TeamPerformance = response && response.data;
        commit("setTeamPerformanceFillers", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchUserLicenseList({ commit, getters }, uid: string): any {
    axios({
      url: consts.serverURL + "user/" + uid + "/appsumo-licenses",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        commit("setLicenseList", response.data);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchAvailablePlans({ commit, getters }): any {
    commit("setAvailablePlansLoading", true);
    axios({
      url: consts.serverURL.replace(
        "mobileapp/v2/",
        "graphql?query={me{availablePlans{id,name,enterprise,bulletPoints{enabled,text},stripePricing{monthlyPrice,yearlyPrice,lifetimePrice}}}}"
      ),
      headers: { Authorization: "Bearer " + getters.JWT },
    }).then(
      (response) => {
        const plans: AvailablePlan[] =
          response && response.data.data.me.availablePlans;
        commit("setAvailablePlans", plans);
        commit("setAvailablePlansLoading", false);
      },
      (error) => {
        handleError(commit, error);
        commit("setAvailablePlansLoading", false);
      }
    );
  },
  fetchUserPlan({ commit, getters }): any {
    commit("setUserPlanLoading", true);
    axios({
      url: consts.serverURL.replace(
        "mobileapp/v2/",
        "graphql?query={me{hasUsedUpFreeTrial,displayStripeManagementButton,subscription{platform,plan{id,name,enterprise}}}}"
      ),
      headers: { Authorization: "Bearer " + getters.JWT },
    }).then(
      (response) => {
        console.log("got user plan", response.data);
        const plan: UserPlan =
          response && response.data.data.me.subscription.plan;
        plan.hasUsedUpFreeTrial = response.data.data.me.hasUsedUpFreeTrial;
        plan.displayStripeManagementButton =
          response.data.data.me.displayStripeManagementButton;
        plan.platform = response.data.data.me.subscription.platform;
        commit("setUserPlan", plan);
        commit("setUserPlanLoading", false);
      },
      (error) => {
        commit("setUserPlanLoading", false);
        handleError(commit, error);
      }
    );
  },
  fetchLearnerTeams(
    { commit, getters },
    currentLearnerTeam?: LearnerTeam,
    onSuccess?: Function,
    onError?: Function
  ): any {
    axios({
      url: consts.serverURL.replace(
        "mobileapp/v2/",
        "graphql?query={me{teams{id,name}}}"
      ),
      headers: { Authorization: "Bearer " + getters.JWT },
    }).then(
      (response) => {
        const learnerTeam: LearnerTeam[] =
          response && response.data.data.me.teams;
        commit("setLearnerTeams", learnerTeam);
        if (onSuccess) {
          onSuccess(learnerTeam);
        }
        if (
          learnerTeam &&
          learnerTeam.length &&
          (!currentLearnerTeam ||
            !learnerTeam.some((team) => team.id === currentLearnerTeam.id))
        ) {
          commit("setLearnerTeam", learnerTeam[0]);
        }
      },
      (error) => {
        handleError(commit, error);
        if (onError) {
          onError(error);
        }
      }
    );
  },
  fetchReviewRequired({ commit, getters }): any {
    axios({
      url: consts.serverURL + "review/" + getters.currentTeamID + "/to-review",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Current to-review Action", response.data);
        let payload: Review[] = [];
        if (response && response.data) {
          payload = response && response.data;
        }
        commit("setSessionReviewRequired", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
  fetchAlreadyReviewed({ commit, getters }): any {
    axios({
      url:
        consts.serverURL +
        "review/" +
        getters.currentTeamID +
        "/already-reviewed",
      headers: { Authentication: getters.JWT },
      cancelToken: source.token,
    }).then(
      (response) => {
        console.log("Current already-review Action", response.data);
        let payload: Review[] = [];
        if (response && response.data) {
          payload = response && response.data;
        }
        commit("setSessionAlreadyReviewed", payload);
      },
      (error) => {
        handleError(commit, error);
      }
    );
  },
};
